import React from 'react'
import RiceLogo1x from '../../static/img/rice-logo-footer.jpg'
import RiceLogo2x from '../../static/img/rice-logo-footer@2x.jpg'
import RiceLogo3x from '../../static/img/rice-logo-footer@3x.jpg'
import LogoDark1x from '../../static/img/co-fes-logo-dark.png'
import LogoDark2x from '../../static/img/co-fes-logo-dark@2x.png'
import LogoDark3x from '../../static/img/co-fes-logo-dark@3x.png'


class Footer extends React.Component{
     constructor(props) {
          super(props);
     }
     render(){
          return(
               <footer id="footer">
                    <div className="container top-footer">
                        <div className="row pt-4 pb-4">
                             <div className="col-md-3 pt-4 pb-4 text-center">
                                  <img src={LogoDark1x} srcSet={`${LogoDark2x} 2x, ${LogoDark3x} 3x`} style={{maxWidth: '268px', objectFit: 'contain'}} />
                             </div>
                             <div className="col-md-1">&nbsp;</div>
                             <div className="col-md-8 pt-4 pb-4">
                                  <div className="row">
                                       <div className="col-md-3 col-sm-5 pt-4">
                                            <ul className="list-group list-group-flush">
                                                 <li className="list-group-item"><h3 className="text-primary mb-0">USEFUL LINKS</h3></li>
                                                 <li className="list-group-item"><a href="https://www.rice.edu" target='_blank' className="text-light">Rice Home</a></li>
                                                 <li className="list-group-item"><a href="https://engineering.rice.edu/" target='_blank' className="text-light">Rice School of Engineering</a></li>
                                                 <li className="list-group-item"><a href="https://registrar.rice.edu/calendars" target='_blank' className="text-light">University Calendar</a></li>
                                                 <li className="list-group-item"><a href="https://www.rice.edu/campus-maps" target='_blank' className="text-light">Maps-Directions</a></li>
                                                 <li className="list-group-item"><a href="mailto:cofes@rice.edu" target='_blank' className="text-light">Feedback</a></li>
                                            </ul>
                                       </div>
                                       <div className="col-md-5 col-sm-7 pt-4">
                                            <ul className="list-group list-group-flush">
                                                 <li className="list-group-item"><h3 className="text-primary mb-0"><a href='/contact' className="text-primary mb-0">CONTACT US</a></h3></li>
                                                 <li className="list-group-item text-light"><strong>Address:</strong> 6100 Main MS-138, Houston, TX, 77005-1827</li>
                                                 <li className="list-group-item text-light"><strong>Mailing Address:</strong> P.O. Box 1892, Houston, TX, 77251-1892</li>
                                            </ul>
                                       </div>
                                       <div className="col-md-4 col-sm-12 pt-4 text-center">
                                            <img className="mt-4" src={RiceLogo1x} srcSet={`${RiceLogo2x} 2x, ${RiceLogo3x} 3x`} style={{maxWidth: '238px', objectFit: 'contain'}} />
                                       </div>
                                  </div>
                             </div>
                        </div>
                   </div>

                     <div className="container-fluid bg-primary pt-4 pb-4">
                       <div className="container">
                            <div className="row">
                                 <div className="col-md-12 text-white">Copyright 2018 | Rice University, Center for Computational Finance and Economic Systems</div>
                            </div>
                       </div>
                     </div>
              </footer>
          )
     }
}
export default Footer
